export function MilesQuota (obj: any) {
    let montoConv = new Intl.NumberFormat("es-GT").format(obj);
    const fechaResultado = "Q. " + montoConv +".00"  ;

    return fechaResultado;
};